import { DefaultBadge } from '@frontend/components/badge';
import { UserStateName } from '@frontend/user/types';
import React from 'react';

import { useUserStateBadge } from './user-state-badge.controller';

const ID = 'user-state-badge';

export interface UserStateBadgeProps {
    state: UserStateName;
}

export const UserStateBadge = (props: UserStateBadgeProps) => {
    const viewProps = useUserStateBadge(props);
    return (
        <DefaultBadge
            id={ID}
            styles={{ container: { color: viewProps.type } }}
            label={viewProps.displayName}
        />
    );
};
